export default __webpack_public_path__ + "static/media/patch.371a1997.png";